import { API_URL } from "../Util/constant";
export async function makeApiRequest(path, params) {
	try {
		var reqHeader = new Headers();
		reqHeader.append("Content-Type", "application/json");
		const response = await fetch(`${API_URL}${path}`, {
			method: "POST",
			body: JSON.stringify(params),
			headers: reqHeader,
			// mode:'no-cors',
			redirect: "follow",
		});
		const rresponse = await response.json();
		if (!rresponse.error) {
			return { result: rresponse };
		} else {
			return { error: rresponse.error.data };
		}
	} catch (error) {
		console.error(error);
		return {
			error: {
				title: "Api request error",
				message: "Api request error",
				error: error,
			},
		};
	}
}


//V1- LOGIN API 
export async function UserLogin(Values) {
	const response = await makeApiRequest("/auth/userlogin", Values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1-  REGISTERATION API 
export async function UserRegistration(Values) {
	const response = await makeApiRequest("/auth/userregister", Values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1-  FORGOT PASSWORD API  
export async function UserForgotPassword(Values) {
	const response = await makeApiRequest("/auth/userforgotpassword", Values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1- GET THEME 
export async function GetTheme(Values) {
	const response = await makeApiRequest("/auth/gettheme", Values);

	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}



